import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3293">
      <Navbar data-id="element-3294" />
      <main data-id="element-3295">
        <ConsularAffairs data-id="element-3296" />
      </main>
      <Footer data-id="element-3297" />
      <FeedbackPopup data-id="element-3298" />
    </div>;
}